import React, { useState, useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import { Avatar } from "@material-ui/core";
import ListItemText from "@material-ui/core/ListItemText";
import { useHistory } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import { Checkbox } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { AppDispatch } from "../../app/store";
import useMedia from "use-media";

import {
  selectTargetUser,
  selectSearchCategory,
  setSearchCategory,
  fetchAsyncGetSelectFollowList,
} from "../home/homeSlice";

import {
  fetchAsyncGetUsersProfile,
  fetchAsyncLoginUser,
  selectLoginUser,
  fetchAsyncSearchUsersProfile,
  selectProfiles,
  fetchAsyncGetLoginProfile,
  selectLoginUserProfile,
} from "../auth/authSlice";

import { PROFILE } from "../../types/types";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(3, 3),
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    backgroundColor: "#f1f9ff",
    position: "fixed",
    width: "100%",
    maxWidth: "66.667%",
  },
  paperRes: {
    padding: theme.spacing(3, 3),
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    backgroundColor: "#f1f9ff",
    position: "fixed",
    width: "100%",
  },
  root: {
    borderRadius: "30px",
  },
  backgroundColor: {
    backgroundColor: "#ffffff",
    height: "100vh",
  },
  categoryContainer: {
    flexDirection: "unset",
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    alignItems: "center",
    justifyContent: "space-between",
  },
  listContainer: {
    margin: theme.spacing(0, 1),
    backgroundColor: "#fff",
    borderRadius: "5px",
    marginTop: 160,
  },
  listBorder: {
    borderBottom: "1px solid #f1f1f1",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  undefinedUser: {
    textAlign: "center",
    marginTop: theme.spacing(3),
  },
  label: {
    "& .MuiFormControlLabel-label": {
      fontSize: 12,
    },
  },
  submit: {
    fontSize: 12,
    height: 35,
    color: "#fff",
    backgroundColor: "#2699FB",
  },
  categoryText: {
    fontSize: 10,
  },
}));

const Search = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const loginUser = useSelector(selectLoginUser);
  const profiles = useSelector(selectProfiles);
  const searchCategory = useSelector(selectSearchCategory);
  const loginUserProfile = useSelector(selectLoginUserProfile);
  const [isSearchCategory, setIsSearchCategory] = useState(false);
  const [filterUsers, setFilterUsers] = useState<PROFILE[]>([
    {
      id: 0,
      username: "",
      user_profile: 0,
      img: null,
      gender_flg: "",
      height: null,
      height_hide_flg: "",
      weight: null,
      weight_hide_flg: "",
      text: null,
      calendar_hide_flg: "",
    },
  ]);
  const isWide = useMedia({ minWidth: "600px" });
  // const selectedProfile = useSelector(selectSelectedProfile);
  //チェックボックスの身長切り替え(チェックが入った時、ログインユーザの身長をsearchCategoryにセット)
  const handleSearchCategoryHeightChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (loginUserProfile?.height !== null) {
      searchCategory.height === 0 &&
        dispatch(
          setSearchCategory({
            ...searchCategory,
            height: loginUserProfile?.height,
          })
        );
      searchCategory.height > 0 &&
        dispatch(
          setSearchCategory({
            ...searchCategory,
            height: 0,
          })
        );
    }
  };
  //チェックボックスの体重切り替え(チェックが入った時、ログインユーザの体重をsearchCategoryにセット)
  const handleSearchCategoryWeightChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (loginUserProfile?.weight !== null) {
      searchCategory.weight === 0 &&
        dispatch(
          setSearchCategory({
            ...searchCategory,
            weight: loginUserProfile?.weight,
          })
        );
      searchCategory.weight > 0 &&
        dispatch(
          setSearchCategory({
            ...searchCategory,
            weight: 0,
          })
        );
    }
  };
  //チェックボックスの性別切り替え(チェックが入った時、ログインユーザの性別をsearchCategoryにセット)
  const handleSearchGenderChange = () => {
    if (loginUserProfile?.gender_flg !== "1") {
      searchCategory.gender === "" &&
        dispatch(
          setSearchCategory({
            ...searchCategory,
            gender: loginUserProfile?.gender_flg,
          })
        );
      searchCategory.gender !== "" &&
        dispatch(
          setSearchCategory({
            ...searchCategory,
            gender: "",
          })
        );
    }
  };
  //検索結果のリスト押下時　対象ユーザのprofileで画面表示
  const goProfile = useCallback(
    async (id: number, user: string) => {
      await dispatch(selectTargetUser({ user_profile: id, username: user }));
      await dispatch(fetchAsyncGetUsersProfile(id));
      await dispatch(fetchAsyncGetSelectFollowList(id));
      history.push("/home/profile");
    },
    [history]
  );

  const handleInputSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setSearchCategory({ ...searchCategory, searchWord: e.target.value })
    );
  };
  //検索ボタン押下時
  const search = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    (searchCategory.searchWord.length > 0 || isSearchCategory === true) &&
      (await dispatch(fetchAsyncSearchUsersProfile(searchCategory)));
  };

  //画面初期表示時、ログインユーザの情報を取得し格納
  useEffect(() => {
    loginUser.id === 0 && dispatch(fetchAsyncLoginUser());
  }, [dispatch]);

  //ログインユーザのプロフィールを取得
  useEffect(() => {
    loginUserProfile.user_profile === 0 &&
      loginUser.id !== 0 &&
      dispatch(fetchAsyncGetLoginProfile());
  }, [loginUser, dispatch]);

  // 検索結果をフィルター
  useEffect(() => {
    if (loginUser.id !== 0) {
      const prof = profiles.filter(
        (profile) => profile.user_profile !== loginUser.id
      );
      setFilterUsers(prof);
    }
  }, [profiles]);

  //検索のカテゴリが選択されているかどうかを searchCategoryBrank にて判別
  useEffect(() => {
    if (searchCategory.height > 0) {
      setIsSearchCategory(true);
    } else if (searchCategory.weight > 0) {
      setIsSearchCategory(true);
    } else if (searchCategory.gender !== "") {
      setIsSearchCategory(true);
    } else {
      setIsSearchCategory(false);
    }
  }, [searchCategory]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        className={classes.backgroundColor}
        component={Paper}
        elevation={6}
        square
      >
        <form
          className={isWide ? classes.paper : classes.paperRes}
          onSubmit={search}
        >
          <Paper className={classes.root}>
            <IconButton type="submit" aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              placeholder="Search Users"
              onChange={handleInputSearch}
              value={searchCategory.searchWord}
            />
          </Paper>

          <FormGroup className={classes.categoryContainer}>
            <div>
              {/* 絞り込み検索が可能かどうか　　身長が設定されている */}
              {loginUserProfile?.height !== null &&
                loginUserProfile?.height !== 0 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={searchCategory.height > 0}
                        onChange={handleSearchCategoryHeightChange}
                        name="height"
                        color="primary"
                      />
                    }
                    label="身長"
                    className={classes.label}
                  />
                )}
              {/* 絞り込み検索が可能かどうか　　体重が設定されている*/}
              {loginUserProfile?.weight !== null &&
                loginUserProfile?.weight !== 0 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={searchCategory.weight > 0}
                        onChange={handleSearchCategoryWeightChange}
                        name="weight"
                        color="primary"
                      />
                    }
                    label="体重"
                    className={classes.label}
                  />
                )}
              {loginUserProfile?.gender_flg !== "1" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={searchCategory.gender !== ""}
                      onChange={handleSearchGenderChange}
                      name="gendar"
                      color="primary"
                    />
                  }
                  label="性別"
                  className={classes.label}
                />
              )}
              {(loginUserProfile?.height !== null &&
                loginUserProfile?.height !== 0) ||
              (loginUserProfile?.weight !== null &&
                loginUserProfile?.weight !== 0) ||
              loginUserProfile?.gender_flg !== "1" ? (
                <div className={classes.categoryText}>
                  あなたと似たユーザーの検索や絞り込みが可能です
                </div>
              ) : (
                ""
              )}
            </div>

            <div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                検索
              </Button>
              {/* )} */}
            </div>
          </FormGroup>
        </form>
        <div className={classes.listContainer}>
          <List dense>
            {filterUsers.length === 0 && (
              <li className={classes.undefinedUser}>
                該当のユーザは存在しません
              </li>
            )}
            {filterUsers.length > 0 &&
              filterUsers[0]?.user_profile !== 0 &&
              filterUsers.map((user) => (
                <ListItem
                  className={classes.listBorder}
                  key={user.user_profile}
                  button
                  onClick={() => goProfile(user.user_profile, user.username)}
                >
                  <ListItemAvatar>
                    <Avatar src={user?.img ? user.img : undefined} />
                  </ListItemAvatar>
                  <ListItemText
                    id={user.username + user.user_profile}
                    primary={user.username}
                  />
                </ListItem>
              ))}
          </List>
        </div>
      </Grid>
      <Grid item></Grid>
    </Grid>
  );
};

export default Search;
